export default __webpack_public_path__ + "static/media/f_socialmedia.b66d5591.svg";